import Decimal from 'decimal.js';

/**
 * 公式工具：plus / minus / times —— 数组版高精度运算（基于 decimal.js）。
 *
 * 设计要点：
 *   - 这些函数会被 formInit.ts 的 onChange 闭包调用（本地用法）。
 *   - 同时 onChange.toString() 会被嵌入 JSX 字符串 → runReactCode 用 new Function 执行，
 *     隔离作用域里闭包不到外层，只能通过 globalThis.__formulas.xxx 访问。
 *   - 因此模块加载时把同一组函数挂到 globalThis.__formulas。
 *
 * 依赖 decimal.js：调用方（FlowCenterModal）传入 Decimal 类到 formInit。
 * 这里也用 import 是因为 filePath 已经被 webpack 处理，toString 时也会变成内部标识符
 * —— 但 init.ts 的工具函数 + globalThis 路径不依赖这里的 Decimal 本地引用，
 * 这里的导入只是为了类型 / 占位（实际在 runReactCode 里另有注入）。
 */
export const formulas = {
  /** 数组相加，返回 number（高精度计算后转回 number） */
  plus(arr) {
    return arr.map(num => new Decimal(num || 0)).reduce((acc, cur) => acc.plus(cur), new Decimal(0)).toNumber();
  },
  /** 数组相减 */
  minus(arr) {
    return arr.map(num => new Decimal(num || 0)).reduce((acc, cur) => acc.minus(cur)).toNumber();
  },
  /** 数组相乘 */
  times(arr) {
    return arr.map(num => new Decimal(num || 0)).reduce((acc, cur) => acc.times(cur), new Decimal(1)).toNumber();
  }
};